import type { DbSection } from '@domain/schemas/contract.schema';
import type { SummarySectionDb } from '@domain/schemas/endorsement-summary.schema';

export const isSummarySection = (section?: Pick<DbSection, 'sk'>): section is SummarySectionDb =>
  Boolean(section?.sk?.startsWith('summary_sections#'));
